module.exports = __webpack_public_path__ + "img/root000.f1f1538f.png";